module.exports = __webpack_public_path__ + "static/media/krishnaveni.bfd14539.png";